var _path, _rect, _path2, _path3, _path4, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _circle, _path5, _path6, _circle2, _path7, _polygon, _polygon2, _path8, _path9, _path10, _path11, _path12, _circle3, _path13, _polygon3, _path14, _path15, _polygon4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    width: 820.61472,
    height: 714.55787,
    viewBox: "0 0 820.61472 714.55787",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "voice_assistant") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M708.72606,261.94463h-3.91268V154.7579a62.03677,62.03677,0,0,0-62.037-62.03684H415.687A62.03678,62.03678,0,0,0,353.65,154.7579V742.79264a62.03677,62.03677,0,0,0,62.037,62.03683H642.77643a62.03676,62.03676,0,0,0,62.037-62.03683V338.242h3.91268Z",
    transform: "translate(-189.69264 -92.72106)",
    fill: "#3f3d56"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.2442,
    y: 682.87113,
    width: 718,
    height: 2,
    fill: "#3f3d56"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M645.27966,108.8609H615.637a22.0105,22.0105,0,0,1-20.37872,30.3233H465.1615a22.01052,22.01052,0,0,1-20.37873-30.3233H417.09643A46.32837,46.32837,0,0,0,370.768,155.18921V742.36127a46.32839,46.32839,0,0,0,46.32843,46.32837H645.27966a46.32838,46.32838,0,0,0,46.32843-46.32837V155.18921A46.32836,46.32836,0,0,0,645.27966,108.8609Z",
    transform: "translate(-189.69264 -92.72106)",
    opacity: 0.2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M261.25515,777.48617l-1.07324-.40234c-.23584-.08887-23.7085-9.082-34.7041-29.47364-10.9961-20.39257-5.61182-44.94531-5.55615-45.19043l.25341-1.11816,1.07276.40234c.23584.08887,23.708,9.082,34.7041,29.47364,10.99609,20.39258,5.61182,44.94531,5.55615,45.19043ZM227.23855,746.661c9.29639,17.24121,27.84521,26.0791,32.54492,28.09668.89356-5.03711,3.6958-25.40625-5.59228-42.63086-9.28711-17.22266-27.84327-26.07422-32.54493-28.09668C220.75222,709.07016,217.951,729.43734,227.23855,746.661Z",
    transform: "translate(-189.69264 -92.72106)",
    fill: "#3f3d56"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M233.881,740.45715c19.76056,11.88861,27.371,35.50266,27.371,35.50266s-24.42779,4.33881-44.18835-7.5498-27.371-35.50266-27.371-35.50266S214.12043,728.56854,233.881,740.45715Z",
    transform: "translate(-189.69264 -92.72106)",
    fill: "#b91256"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 238.66728,
    y: 229.88716,
    width: 43.96154,
    height: 10.58333,
    fill: "#b91256"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 419.39805,
    y: 229.88716,
    width: 15.46795,
    height: 10.58333,
    fill: "#b91256"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 450.33395,
    y: 229.88716,
    width: 15.46795,
    height: 10.58333,
    fill: "#b91256"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 298.09677,
    y: 229.88716,
    width: 105.01923,
    height: 10.58333,
    fill: "#b91256"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 364.03907,
    y: 298.27177,
    width: 15.46795,
    height: 10.58333,
    fill: "#b91256"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 394.97497,
    y: 298.27177,
    width: 15.46795,
    height: 10.58333,
    fill: "#b91256"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 242.73779,
    y: 298.27177,
    width: 105.01923,
    height: 10.58333,
    fill: "#b91256"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 364.85318,
    y: 253.49613,
    width: 43.96154,
    height: 10.58333,
    fill: "#b91256"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 424.28266,
    y: 253.49613,
    width: 43.96154,
    height: 10.58333,
    fill: "#b91256"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 214.2442,
    y: 253.49613,
    width: 15.46795,
    height: 10.58333,
    fill: "#b91256"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 245.1801,
    y: 253.49613,
    width: 105.01923,
    height: 10.58333,
    fill: "#b91256"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 463.36633,
    y: 369.01207,
    width: 43.96154,
    height: 10.58333,
    transform: "translate(781.00156 655.8864) rotate(-180)",
    fill: "#b91256"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 403.93684,
    y: 369.01207,
    width: 43.96154,
    height: 10.58333,
    transform: "translate(662.14258 655.8864) rotate(-180)",
    fill: "#b91256"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 642.46889,
    y: 369.01207,
    width: 15.46795,
    height: 10.58333,
    transform: "translate(1110.7131 655.8864) rotate(-180)",
    fill: "#b91256"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 521.98171,
    y: 369.01207,
    width: 105.01923,
    height: 10.58333,
    transform: "translate(959.29002 655.8864) rotate(-180)",
    fill: "#b91256"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 341.49541,
    cy: 453.87113,
    r: 40,
    fill: "#b91256"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M789.10665,310.20453c-11.60691-19.6121-34.57027-20.52611-34.57027-20.52611s-22.37648-2.86148-36.73085,27.008c-13.37942,27.8408-31.84473,54.72165-2.97276,61.239l5.21511-16.23177,3.22969,17.4402a112.96671,112.96671,0,0,0,12.35324.21113c30.91954-.99827,60.36573.29207,59.4176-10.80316C793.788,353.79224,800.27484,329.07528,789.10665,310.20453Z",
    transform: "translate(-189.69264 -92.72106)",
    fill: "#2f2e41"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M747.30736,347.13835s15,21,6,38,21,35,21,35l22-48s-26-17-19-33Z",
    transform: "translate(-189.69264 -92.72106)",
    fill: "#fbbebe"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 567.61472,
    cy: 237.41728,
    r: 26,
    fill: "#fbbebe"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M667.32787,360.19421l21.72805-28.03377s7.6506-29.38483,18.73125-27.89516-4.3766,35.23983-4.3766,35.23983l-21.58945,31.03056Z",
    transform: "translate(-189.69264 -92.72106)",
    fill: "#fbbebe"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "587.615 640.417 594.615 677.417 609.615 681.417 605.615 637.417 587.615 640.417",
    fill: "#fbbebe"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "738.615 600.417 765.615 637.417 776.615 642.417 785.615 627.417 758.615 592.417 738.615 600.417",
    fill: "#fbbebe"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M771.30736,404.13835,754.62626,382.179s-32.3189,5.95934-35.3189,8.95934,8,58,8,58,2,15,11,23l9,6,74-15,2.78246-32.92581a86.41011,86.41011,0,0,0-22.78243-66.07417l0,0-12.8758,1.76021Z",
    transform: "translate(-189.69264 -92.72106)",
    fill: "#575a89"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M723.30736,393.13835l-5-2-23-2s-8-2-6-6,4-5,0-6-5-2-4-5,7-9,7-9l-17-14s-.9201.6508-2.4073,1.85491c-8.44043,6.83375-35.1472,31.48942-15.5927,56.14509,23,29,50,46,72,40Z",
    transform: "translate(-189.69264 -92.72106)",
    fill: "#575a89"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M745.30736,473.13835v14s-9,17-6,33,4,24,4,24a136.53331,136.53331,0,0,0,7,40c7,20-16,151,13,153s45,4,54-6-15-182-15-182,82,171,99,164,60-23,55-32-131-209-131-209l-4-9Z",
    transform: "translate(-189.69264 -92.72106)",
    fill: "#2f2e41"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M793.30736,763.13835s-16-1-16,4-8,22-8,22-6,20,10,18,26-20,26-20l-4-19Z",
    transform: "translate(-189.69264 -92.72106)",
    fill: "#2f2e41"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M960.30736,728.13835s-14-9-13-3,2,22,9,23,28,7,29,9,25,10,25-3-15-23-15-23l-17-13s-11-1-13,6S960.30736,728.13835,960.30736,728.13835Z",
    transform: "translate(-189.69264 -92.72106)",
    fill: "#2f2e41"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 567.65422,
    cy: 197.05669,
    r: 16.60376,
    fill: "#2f2e41"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M738.99533,285.40835a16.6044,16.6044,0,0,1,14.856-16.51042,16.60376,16.60376,0,1,0,0,33.02084A16.6044,16.6044,0,0,1,738.99533,285.40835Z",
    transform: "translate(-189.69264 -92.72106)",
    fill: "#2f2e41"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "594.282 215.593 571.596 203.709 540.266 208.571 533.785 237.199 549.92 236.579 554.428 226.061 554.428 236.405 561.873 236.119 566.194 219.374 568.895 237.199 595.363 236.659 594.282 215.593",
    fill: "#2f2e41"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M782.6166,475.45507l-34.98722.94591s-29.85391,5.809-28.17895-6.24071,30.79949-7.83525,30.79949-7.83525l31.88021-4.86338Z",
    transform: "translate(-189.69264 -92.72106)",
    fill: "#fbbebe"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M810.29862,362.44321a7.46666,7.46666,0,0,1,8.23586,5.128c6.84947,21.584,27.95077,93.81335,6.98533,103.72284-24.69358,11.67164-42.714,11.15847-42.714,11.15847l-9.64534-23.748,8.78051-8.24031,9.37441-60.27537,4.492-25.55048Z",
    transform: "translate(-189.69264 -92.72106)",
    fill: "#575a89"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "614.115 309.917 610.115 349.917 575.115 364.917 614.115 355.917 614.115 309.917",
    opacity: 0.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.e8d505cd35bdcf11c867f6a63661c4d2.svg";
export { ForwardRef as ReactComponent };